import useBaseMessageError from './useBaseMessageError';
import useMessage from './useMessage';

function useMessageError() {
  return useBaseMessageError({ hook: useMessage });
}

export default useMessageError;
